import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectDropdown from "../../../../components/dropdown/selectdropdown/SelectDropdown";
import Label from "../../../../components/label/Label";
import { LABEL_WEIGHT } from "../../../../components/label/constants";
import RichGrid from "../../../../components/richgrid/RichGrid";
import commonStyles from "../../FormSection.styles";
import { componentKey, setSelectedState, setSelectedForm, setFormList, setSelectedTaxYear, setSelectedPayer, setPayersList, setRejectedStatePayrollFormsGrid, setSelectedRejectedStatePayrollForms, setPaginationState, setDeleteStatePayrollRejectedFormModal, setClickedFormDetails, setUrlFormIdParam, setUrlPayerIdParam  } from "./ReviewRejectedStatePayrollFormsSlice";
import { getStateList, getFormsList, getPayersBySelectedForm, getRejectedStatePayrollFormsGridData, resubmitStatePayrollRejectedForm, deleteStatePayrollRejectedForm, viewStatePayrollRejectedFormPDF } from "./ReviewRejectedStatePayrollFormsSaga";
import useGarbageCollector from "../../../../../libs/garbagecollector/garbageCollectorHooks";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import Button from "../../../../components/button/Button";
import { BUTTON_TYPE } from "../../../../components/button/constants";
import { ROW_SELECTION_OPTIONS } from "../../../../components/richgrid/constants";
import Icons from '../../../../components/icons/Icons';
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import { REVIEW_REJECTED_LOADING_STATES, REVIEW_REJECTED_STATES_MESSAGE_MAP } from "../constants";
import Loadable from "../../../../components/loadable/Loadable";
import { COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP } from "../../../constants/constants";
import useFormatTIN from "../../../../../libs/customhooks/useFormatTIN";
import ConfirmationPopup from "../../../../components/popup/confirmationpopup/ConfirmationPopup";
import { EDIT_FORM_ORIGIN, QUERY_PARAMS, FORM_SECTION_ROUTES } from "../../constants";
import useTxNavigate from "../../../../../libs/txnavigate/TxNavigateHook";
import General from "../../../../../libs/utility/General";
import useTxSearchParams from "../../../../../libs/txsearchparams/TxSearchParamsHook";

function ReviewRejectedStatePayrollForms() {
    useGarbageCollector(componentKey);
    const dispatch = useDispatch();
    const navigate = useTxNavigate();
    const [queryParams, setQueryParams] = useTxSearchParams();
    const { formatTIN } = useFormatTIN()
    const { loadingState, stateList, selectedState, formList, selectedForm, taxYearList, selectedTaxYear, payersList, selectedPayer, rejectedStatePayrollFormsGrid, selectedRejectedStatePayrollForms, paginationState, formListLoadingState, payerListLoadingState, deleteStatePayrollRejectedFormModal, clickedFormDetails, gridDataLoadingState,reloadReviewRejectedGridData , urlFormIdParam, urlPayerIdParam  } = useSelector((state) => state[componentKey]);

    useEffect(() => {
        const stateParamFromUrl = queryParams.get(QUERY_PARAMS.STATE_ID)
        const formIdParamFromUrl = queryParams.get(QUERY_PARAMS.FORM_ID)
        const taxYearParamFromUrl = queryParams.get(QUERY_PARAMS.TAX_YEAR)
        const payerIdParamFromUrl = queryParams.get(QUERY_PARAMS.PAYER_ID)

        dispatch(setUrlFormIdParam(formIdParamFromUrl))
        dispatch(setUrlPayerIdParam(payerIdParamFromUrl))
        dispatch(getStateList({ urlStateParam: stateParamFromUrl, urlTaxYearParam: taxYearParamFromUrl }));
    }, [])

    useEffect(() => {
        if (selectedState?.value) {
            dispatch(getFormsList({ stateName: selectedState?.value, urlFormIdParam: urlFormIdParam }));
        } else {
            dispatch(setFormList([]));
        }
        dispatch(setSelectedForm({ label: "", value: "" }));
        dispatch(setRejectedStatePayrollFormsGrid([]));
        dispatch(setSelectedRejectedStatePayrollForms([]))
    }, [selectedState])

    useEffect(() => {
        if (selectedForm?.value) {
            dispatch(getPayersBySelectedForm({ formId: selectedForm?.value, urlPayerIdParam: urlPayerIdParam }));
        } else {
            dispatch(setPayersList([]));
        }
        dispatch(setSelectedPayer({ label: "", value: "" }));
        dispatch(setRejectedStatePayrollFormsGrid([]));
        dispatch(setSelectedRejectedStatePayrollForms([]))
    }, [selectedForm])

    useEffect(() => {
        if (reloadReviewRejectedGridData) {
            if (selectedForm?.value && selectedTaxYear?.value && selectedPayer?.value) {
                getGridRecords(paginationState?.PageNumber, paginationState?.PageSize);
            }
        }
    }, [reloadReviewRejectedGridData])

    const getGridRecords = (PageNumber, PageSize) => {
        dispatch(getRejectedStatePayrollFormsGridData({
            payerId: selectedPayer?.PayerDetailId,
            taxYear: selectedTaxYear?.value,
            formId: selectedForm?.value,
            PageNumber: PageNumber,
            PageSize: PageSize,
        }))
    }

    const REVIEW_REJECTED_STATE_PAYROLL_FORMS_COLUMN = [
        {
            field: "Date",
            header: (
                <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...commonStyles.text, ...commonStyles.date }}>
                    Date
                </Label>
            ),
            renderLogic: (row, idx) => (<span style={{ ...commonStyles.text, ...commonStyles.date }}>{row?.Date || "-"}</span>),
        },
        {
            field: "TIN",
            header: <Label weight={LABEL_WEIGHT[700]}>TIN</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{formatTIN(row?.TINType, row?.TIN) || "-"}</span>,
        },
        {
            field: "PayerName",
            header: <Label weight={LABEL_WEIGHT[700]}>Payer Name</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.Name || "-"}</span>,
        },
        {
            field: "UserEmail",
            header: <Label weight={LABEL_WEIGHT[700]}>User Email</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.MemberEmail || "-"}</span>,
        },
        {
            field: "Action",
            header: (
                <Label Label weight={LABEL_WEIGHT[700]}>
                    Action
                </Label>
            ),
            renderLogic: (row, idx) => (
                <div style={commonStyles.actionButtons}>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[`${REVIEW_REJECTED_LOADING_STATES.FETCHING_VIEW_PDF_LIST_LOADING}-${row?.FormId}`]}
                        messageMap={REVIEW_REJECTED_STATES_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    >
                        <Button title={'View PDF'} style={commonStyles.buttonBackgroundWIcon} onClickCb={() => dispatch(viewStatePayrollRejectedFormPDF({
                            formId: row?.FormId,
                            payerId: selectedPayer?.PayerDetailId,
                            formTypeId: selectedForm?.value,
                            payerName: selectedPayer?.LastName,
                        }))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.VIEW_ICON} /></Button>
                    </Loadable>
                    <Button title={'Edit'} style={commonStyles.buttonBackgroundWIcon}
                        onClickCb={() => {
                            const queryObj = {
                                [QUERY_PARAMS.STATENAME]: selectedState?.value.toUpperCase(),
                                [QUERY_PARAMS.FORM_NAME]: selectedForm?.FormName1,
                                [QUERY_PARAMS.YEAR]: selectedTaxYear?.value,
                                [QUERY_PARAMS.FORM_RECORD_ID]: row?.FormId,
                                metaData: JSON.stringify({
                                    [EDIT_FORM_ORIGIN]: FORM_SECTION_ROUTES.REVIEW_REJECTED_FORMS,
                                })

                            }
                            const queryParamsStr = General.convertObjToQueryString(queryObj)

                            navigate(`/${[FORM_SECTION_ROUTES.FORMS]}/${[FORM_SECTION_ROUTES.CREATENEW]}?${queryParamsStr}`);
                        }}
                    >
                        <Icons familyName={'vec'} iconName={VEC_ICON_NAME.EDIT_ICON} />
                    </Button>
                    <Button title={'Delete'} style={commonStyles.buttonBackgroundWIcon} onClickCb={() => {
                        dispatch(setClickedFormDetails(row));
                        dispatch(setDeleteStatePayrollRejectedFormModal(true))
                    }}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.DELETE_ICON} /></Button>
                </div>
            ),

        },
    ];
    return (
        <div>
            <div style={commonStyles.dropdownContainer}>
                <div style={commonStyles.selectDropdown}>
                    <div>
                        <Loadable
                            currentState={loadingState.state}
                            loadingStates={[REVIEW_REJECTED_LOADING_STATES.STATES_LIST_LOADING]}
                            messageMap={REVIEW_REJECTED_STATES_MESSAGE_MAP}
                            isNewLoadable={true}
                        >
                            <SelectDropdown
                                name="selectedState"
                                label="State Name*"
                                placeHolder="Please select a state"
                                options={stateList}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedState(selectedOption));

                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.STATE_ID, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.STATE_ID)
                                    }
                                    setQueryParams(queryParams);

                                }}
                                value={selectedState}
                            />
                        </Loadable>
                    </div>
                    <div>
                        <Loadable
                            currentState={formListLoadingState.state}
                            loadingStates={[REVIEW_REJECTED_LOADING_STATES.FORMS_LIST_LOADING]}
                            messageMap={REVIEW_REJECTED_STATES_MESSAGE_MAP}
                            isNewLoadable={true}
                        >
                            <SelectDropdown
                                name="selectedForm"
                                label="Form Name *"
                                placeHolder="Please select a form"
                                options={formList}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedForm(selectedOption));

                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.FORM_ID, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.FORM_ID)
                                    }
                                    setQueryParams(queryParams);
                                }}
                                value={selectedForm}
                            />
                        </Loadable>
                    </div>
                    <div>
                        <SelectDropdown
                            name="selectedTaxYear"
                            label="Tax Year *"
                            placeHolder="Please select a tax year"
                            options={taxYearList}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedTaxYear(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.TAX_YEAR, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.TAX_YEAR)
                                }
                                setQueryParams(queryParams);
                            }}
                            value={selectedTaxYear}
                        />
                    </div>
                    <div>
                        <Loadable
                            currentState={payerListLoadingState.state}
                            loadingStates={[REVIEW_REJECTED_LOADING_STATES.PAYERS_LIST_LOADING]}
                            messageMap={REVIEW_REJECTED_STATES_MESSAGE_MAP}
                            isNewLoadable={true}
                        >
                            <SelectDropdown
                                name="selectedPayer"
                                label="Payer *"
                                placeHolder="Please select a payer"
                                options={payersList}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedPayer(selectedOption));

                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.PAYER_ID, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.PAYER_ID)
                                    }
                                    setQueryParams(queryParams);
                                }}
                                value={selectedPayer}
                            />
                        </Loadable>
                    </div>
                    <Button
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        onClickCb={() => {
                            if (selectedState?.label && selectedForm?.value && selectedPayer?.value && selectedTaxYear?.value) {
                                dispatch(getRejectedStatePayrollFormsGridData({
                                    formId: selectedForm?.value,
                                    payerId: selectedPayer?.value,
                                    taxYear: selectedTaxYear?.value,
                                    PageNumber: paginationState?.PageNumber,
                                    PageSize: paginationState?.PageSize,
                                }))
                            } else {
                                dispatch(addNotifications({ heading: "Error", message: "Please select state, form, tax year and payer" }))
                            }
                        }}>
                        Search
                    </Button>

                    {rejectedStatePayrollFormsGrid.length ? <Loadable currentState={loadingState.state} loadingStates={[REVIEW_REJECTED_LOADING_STATES.RESUBMIT_FORMS_LOADING]} messageMap={REVIEW_REJECTED_STATES_MESSAGE_MAP} isNewLoadable={true}
                    ><Button
                        style={{ ...commonStyles.button, ...commonStyles.resubmitBtn }}
                        onClickCb={() => {
                            if (selectedRejectedStatePayrollForms.length) {
                                dispatch(resubmitStatePayrollRejectedForm({
                                    formIds: selectedRejectedStatePayrollForms.map(f => f.FormId).toString(),
                                    payerId: selectedPayer?.PayerDetailId,
                                    formName: selectedForm?.FormName1,
                                    payerName: selectedPayer?.LastName,
                                    taxyear: selectedTaxYear?.value,
                                    paginationState,
                                    formId: selectedForm?.value
                                }))
                            } else {
                                dispatch(addNotifications({ heading: "Error", message: "Please select a form" }))
                            }
                        }}
                    >Resubmit Form</Button></Loadable> : null}

                </div>
            </div>
            <Loadable
                currentState={gridDataLoadingState.state}
                loadingStates={[COMMON_LOADING_STATES.GRID_LOADING]}
                messageMap={COMMON_LOADING_STATES_MESSAGE_MAP}
                isNewLoadable={true}
            >
                <RichGrid
                    selectable={true}
                    data={rejectedStatePayrollFormsGrid}
                    columns={REVIEW_REJECTED_STATE_PAYROLL_FORMS_COLUMN}
                    extractRowKey={(row) => row.FormId}
                    selectedRows={selectedRejectedStatePayrollForms}
                    onHeaderSelectionChangeCallBack={(selectedData)=>dispatch(setSelectedRejectedStatePayrollForms(selectedData))}
                    onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedRejectedStatePayrollForms(selectedData))}
                    paginationProps={{
                        skip: paginationState?.Skip,
                        take: paginationState?.PageSize,
                        takeOptions: ROW_SELECTION_OPTIONS,
                        total: paginationState?.total,
                        onChangeTakeCb: (newTake) => {
                            dispatch(setPaginationState({ ...paginationState, PageSize: newTake, PageNumber: 1, Skip: 0 }));
                            getGridRecords(1, newTake)
                        },
                        onChange: (take, skip) => {
                            dispatch(setPaginationState({ ...paginationState, PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }));
                            getGridRecords(Math.ceil((take + skip) / take), take)
                        },
                    }}

                />
            </Loadable>

            {deleteStatePayrollRejectedFormModal && <ConfirmationPopup
                title={"Are you sure?"}
                bodyText={`Are you sure you want to delete this form?`}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={deleteStatePayrollRejectedFormModal}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        dispatch(deleteStatePayrollRejectedForm({
                            formSubmissionId: clickedFormDetails?.FormId,
                            selectedForm,
                            selectedRejectedStatePayrollForms,
                            rejectedStatePayrollFormsGrid,
                            taxyear: selectedTaxYear?.value,
                            paginationState,
                            payerId: selectedPayer?.value
                        }))
                    },
                    confirmationButtonText: "Delete",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => dispatch(setDeleteStatePayrollRejectedFormModal(false)),
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                showClose={false}
                loadingState={loadingState}
                loaderLoadingStates={[REVIEW_REJECTED_LOADING_STATES.DELETE_MODAL_LOADING]}
                loaderMessageMap={REVIEW_REJECTED_STATES_MESSAGE_MAP}
                preserveLoaderChildMount={false}
            />}
        </div>
    )

    
};
export default ReviewRejectedStatePayrollForms;